const CodeLoginPage = r => require.ensure([], () => r(require('../../views/login/components/CodeLoginPage.vue')), 'CodeLoginPage');
const UPLoginPage = r => require.ensure([], () => r(require('../../views/login/components/UPLoginPage.vue')), 'UPLoginPage');
const LoginChildrenRouter = [
  {
    path: "/login/CodeLoginPage",
    name: "CodeLoginPage",
    component: CodeLoginPage, 
  },
  {
    path: "/login/UPLoginPage",
    name: "UPLoginPage",
    component: UPLoginPage,
  },
];
export default LoginChildrenRouter
